import request from "@utils/request";

export function getDataLargeVolumeUSD(query) {
    return request({
        url: 'alert/data/large-volume-usd',
        method: 'get',
        params: query
    })
}
